export var LangCodes = /*#__PURE__*/function (LangCodes) {
  LangCodes["ru_RU"] = "ru_RU";
  LangCodes["en_GB"] = "en_GB";
  return LangCodes;
}({});